import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-relative tw-w-screen tw-h-screen tw-overflow-hidden tw-bg-primary tw-text-white" }
const _hoisted_2 = {
  key: 0,
  class: "tw-fixed tw-z-10 tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-4xl tw-font-bold tw-mb-1.5" }, "Error", -1)
const _hoisted_4 = { class: "tw-text-3xl" }
const _hoisted_5 = {
  key: 2,
  class: "image-error-wrapper tw-text-4xl tw-font-bold tw-uppercase tw-mb-1.5"
}
const _hoisted_6 = { class: "tw-text-xl tw-absolute tw-right-8 tw-top-2 tw-z-50" }
const _hoisted_7 = { class: "tw-absolute tw-bottom-2 tw-right-8 tw-text-white tw-text-sm tw-z-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExamIntro = _resolveComponent("ExamIntro")!
  const _component_ExamQuestion = _resolveComponent("ExamQuestion")!
  const _component_ExamMark = _resolveComponent("ExamMark")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.examError.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.examError.message), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.view.image && !_ctx.isImageError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({
        backgroundImage: `url(${_ctx.originUrl}${_ctx.view.image})`,
      }),
          class: "tw-absolute tw-inset-0 tw-bg-center tw-bg-cover tw-bg-no-repeat"
        }, null, 4))
      : _createCommentVNode("", true),
    (_ctx.view.image && _ctx.isImageError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Error: Image not found "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-relative tw-h-full tw-flex tw-flex-col tw-justify-between tw-container tw-mx-auto", _ctx.view.isQuestion && 'tw-py-10'])
    }, [
      _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.brand), 1),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ExamIntro, {
            key: 0,
            view: { content: 'LOADING...' }
          }, null, 8, ["view"]))
        : (_ctx.view.isQuestion)
          ? (_openBlock(), _createBlock(_component_ExamQuestion, {
              key: 1,
              view: _ctx.view
            }, null, 8, ["view"]))
          : (_openBlock(), _createBlock(_component_ExamIntro, {
              key: 2,
              view: _ctx.view
            }, null, 8, ["view"]))
    ], 2),
    (_ctx.showMark)
      ? (_openBlock(), _createBlock(_component_ExamMark, {
          key: 3,
          mark: _ctx.mark,
          class: "tw-left-10 tw-top-1"
        }, null, 8, ["mark"]))
      : _createCommentVNode("", true),
    (_ctx.showMark)
      ? (_openBlock(), _createBlock(_component_ExamMark, {
          key: 4,
          mark: _ctx.mark,
          class: "tw-right-10 tw-bottom-40"
        }, null, 8, ["mark"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.examId), 1)
  ]))
}